import React, {useRef, useState} from 'react';
import {Button} from 'primereact/button';
import {IUserSignatureProps} from '../../../utils/cellInterfaces';
import {Tooltip} from 'primereact/tooltip';
import {ConfirmDialog} from 'primereact/confirmdialog';
import {Toast} from 'primereact/toast';

import './signature.css';


export function UserSignature(props: IUserSignatureProps) {
    // @ts-ignore
    const dateDisplay = new Date(props.value.signedAt);
    const [visible, setVisible] = useState<boolean>(false);
    const toast = useRef(null);

    var datestring = dateDisplay.getFullYear() + "-" + ("0" + (dateDisplay.getMonth() + 1)).slice(-2) + "-" + ("0" + dateDisplay.getDate()).slice(-2)
        + " " + ("0" + dateDisplay.getHours()).slice(-2) + ":" + ("0" + dateDisplay.getMinutes()).slice(-2);

    var className = makeid(10);
    var targetClassName = '.' + className;

    function makeid(length: number) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    const accept = () => {
        props.changeHandler();
    }

    return <div className='p-inputtext' style={{border: '0px', backgroundColor: 'transparent', display: "flex",justifyContent:"center"}}

    >
        <Toast ref={toast}/>
        <Tooltip target={targetClassName} mouseTrack mouseTrackLeft={10}/>
        {props.value && props.value.signed ? (
            <span style={{display: "flex", flexWrap: "nowrap"}}>
                    <span className={className + " non-printable"}
                          data-pr-tooltip={`Signed by ${props.value.display} at ${datestring}`}>
                        <i className='pi pi-lock '/>
                    </span>
                    <span className={"black-color-font"} style={{color: 'forestgreen', paddingLeft: '10px', fontSize: '14px', textAlign: 'center'}}>
                        {props.value.display}
                    </span>
                </span>
        ) : (
            <span className={"non-printable"} style={{color: 'crimson', display: "flex", flexWrap: "nowrap", alignItems: "center"}}>
                    <Button className='p-button-icon' style={{
                        backgroundColor: 'crimson',
                        border: 'crimson',
                        padding: '2px',
                        paddingLeft: '5px',
                        paddingRight: '5px'
                    }}
                            onClick={() => setVisible(true)}
                        disabled={props.isInEditMode}
                    >
                        <i className='pi pi-lock' style={{margin: '2px'}}/>
                    </Button>
                    <span style={{paddingLeft: '10px', fontSize: '14px', textAlign: 'center'}}>Unsigned</span>
                </span>
        )
        }

        <ConfirmDialog visible={visible} onHide={() => setVisible(false)}
                       message="Do you really want to sign this entry/row? Further modifications will not be allowed."
                       acceptClassName='p-button-info' rejectClassName='p-button-text p-button-danger'
                       header="Signature confirmation" icon="pi pi-lock" accept={accept} reject={() => {
        }}/>
    </div>
}